type Variant = "compact" | "detail";

interface CandidateReferenceBadgeProps {
  referenceNumber: number;
  variant?: Variant;
}

const COMPACT_CLASSES =
  "inline-flex items-center rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-mono font-medium text-gray-500 dark:bg-gray-800 dark:text-gray-400";

const DETAIL_CLASSES = "ml-2 font-mono text-text-muted";

export function CandidateReferenceBadge({
  referenceNumber,
  variant = "compact",
}: CandidateReferenceBadgeProps) {
  const label = `#${referenceNumber}`;
  const title = `Candidate reference ${label} — used in chat and for deduping`;
  const className = variant === "detail" ? DETAIL_CLASSES : COMPACT_CLASSES;

  return (
    <span className={className} title={title}>
      {label}
    </span>
  );
}
